import styled from 'styled-components';
import React from 'react';
import { Icon } from 'semantic-ui-react';
import {Link} from 'react-router-dom';

const ChannelWrapper= styled.div`
    grid-column:2;
    grid-row:1/4;
    background-color:#4e3a4c;
    color:#958993;
`;
const TeamNameHeader=styled.h1`
    color:#fff;
    font-size:20px;
`;

const SideBarList=styled.div`
    width:100%;
    list-style:none;
    padding-left:0px;
    margin-top:8px;
`;

const paddingLeft='padding-left:10px';
const SideBarListItem=styled.li`
    padding:2px;
    ${paddingLeft};
    &:hover{
        background:#3e313c;
    }
`;
const SideBarListHeader=styled.div`
    ${paddingLeft};
`;

const PushLeft=styled.div`
    ${paddingLeft};
`;
const Green=styled.span`color:#38978d`;

const Bubble=({on=true})=>(on?<Green>•</Green>:'○')

const channel = ({id,name},teamId)=><Link to={`/view-team/${teamId}/${id}`}><SideBarListItem key={`channel-${id}`}>{`# ${name}`}</SideBarListItem></Link>
const user = ({id,name})=><SideBarListItem key={`user-${id}`}><Bubble/>{name}</SideBarListItem>

export default ({teamName,userName,channels,users,isOwner, onAddChannelClick,teamId , onInviteClick})=>(
    <ChannelWrapper>
        <PushLeft>
            <TeamNameHeader>{teamName}</TeamNameHeader>
            {userName}
        </PushLeft>
        <div>
            <SideBarList><SideBarListHeader>Channels{isOwner &&<Icon onClick={onAddChannelClick} name="add circle"/>}</SideBarListHeader>{channels.map((c)=>channel(c,teamId))}</SideBarList>
        </div>
        <div>
            <SideBarList><SideBarListHeader>Direct Messages</SideBarListHeader>{users.map(user)}</SideBarList>
        </div>
        {isOwner &&<div>
            <PushLeft>
                <a  href="#invite" onClick={onInviteClick}>
                + Invite
                </a>
            </PushLeft>
        </div>
        }
    </ChannelWrapper>
);